type NetworkType =
  | "facebook"
  | "twitter"
  | "instagram"
  | "snapchat"
  | "tiktok"
  | "youtube"
  | "spotify"
  | "apple"
  | "amazon"
  | "linkedin"
  | "soundcloud"
  | "tidal"
  | "napster";

export interface SocialNetwork {
  network: NetworkType;
  handle: string;
}

export const SOCIAL_NETWORK_LIST: NetworkType[] = [
  "facebook",
  "twitter",
  "instagram",
  "snapchat",
  "tiktok",
  "youtube",
  "spotify",
  "apple",
  "amazon",
  "soundcloud",
  "tidal",
];
